import { createAsyncThunk } from '@reduxjs/toolkit';
import { Keys, locale } from 'src/i18n';
import axios from 'src/workspace/axios';
import {
  setBulkDownloadJobData,
  setBulkDownloadStatus,
  setError,
} from '../slice';
import { BASE_URL } from '../thunk';
import { POLL_INTERVAL, STOP_POLLING_STATUSES } from './constants';
import { getJobDetailsApi, normaliseJobDetails } from './queries';

let pollIntervalId: number | null = null;

export const cancelDownloadJob = createAsyncThunk(
  'jobs/cancelDownloadJob',
  async (jobId: string, { dispatch }) => {
    try {
      await axios.put(`${BASE_URL}/jobs/${jobId}/status?status=CANCELLED`);
    } catch (error) {
      dispatch(setError({ message: locale(Keys.ERROR_CANCELLING_DOWNLOAD) }));
    }
    throw new Error(locale(Keys.ERROR_CANCELLING_DOWNLOAD));
  },
);

const onActivate = ({ dispatch, props }) => {
  const { jobId, actionType } = props;

  if (!jobId) return;
  const pollJobStatus = async () => {
    try {
      dispatch(setBulkDownloadStatus(true));
      const jobDetailsApi = getJobDetailsApi(jobId, actionType);
      const response = await axios.get(jobDetailsApi);
      dispatch(setBulkDownloadStatus(false));
      const { payload } = response?.data || {};
      const jobDetails = normaliseJobDetails(payload, actionType);
      dispatch(
        setBulkDownloadJobData({
          jobId,
          jobDetails,
        }),
      );
      if (STOP_POLLING_STATUSES.includes(response.data?.payload?.status)) {
        if (pollIntervalId) {
          clearInterval(pollIntervalId);
          pollIntervalId = null;
        }
      }
    } catch (error) {
      if (pollIntervalId) {
        clearInterval(pollIntervalId);
        pollIntervalId = null;
      }
    }
  };

  pollJobStatus();

  pollIntervalId = window.setInterval(pollJobStatus, POLL_INTERVAL);
};

const onDeactivate = () => {
  if (pollIntervalId) {
    clearInterval(pollIntervalId);
    pollIntervalId = null;
  }
};

export default { onActivate, onDeactivate };
